<template>
  <span>
  <span v-for="(t, idx) in tags" :key="t.tag">
    <b-tooltip :target="() => $refs.tag[idx]" placement="top" v-if="t.createdby_user_userid">
      By {{ t.createdby_user_name }} on {{ t.created | date }}
    </b-tooltip>
  <b-badge class="cursor-pointer" ref="tag" :class="tagClass" variant="secondary">
    <div class="d-flex flex-row">
      <slot name="prepend" :tag="t"/>
      <div class="flex-fill px-3">{{ t.tag }}</div>
      <slot name="append" :tag="t"/>
    </div>
  </b-badge>
  </span>
  </span>
</template>

<script>
export default {
  name: "tag-list",
  props: {
    tags: Array,
    tagClass: {
      type: String,
      default: 'mr-2 mb-2'
    }
  },
}
</script>


<style scoped>

</style>